import type { ReactNode } from 'react';
import styles from './popup-card.module.scss';

/** One column of a card: its [label, value] pairs. */
export type PopupCardColumn = [string, ReactNode][];

interface PopupCardProps {
  /** The card's name, as text or a link. */
  title: ReactNode;
  /** The labelled fields, laid out in columns. */
  columns: PopupCardColumn[];
  /** Anything under the fields (a TypeCurve area's Associated Links). */
  children?: ReactNode;
}

/**
 * A dataset feature's card on the Map Query map: its name over columns of labelled
 * fields, as the Petrotech footprints and Areas show them.
 * @param {PopupCardProps} props The name, the columns and anything below them.
 * @return {JSX.Element} The card.
 */
export function PopupCard({
  title,
  columns,
  children,
}: PopupCardProps): JSX.Element {
  return (
    <div className={styles.card}>
      <span className={styles.name}>{title}</span>
      <div className={styles.columns}>
        {columns.map((items) => (
          <dl key={items[0]?.[0] ?? 'empty'} className={styles.fields}>
            {items.map(([label, value]) => (
              <div key={label} className={styles.field}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        ))}
      </div>
      {children}
    </div>
  );
}
